import React from 'react';

interface ResizeHandleProps {
  columnKey: string;
  width: number;
  minWidth?: number;
  onResize: (columnKey: string, newWidth: number) => void;
}

/**
 * ResizeHandle component for draggable column resizing in tables.
 * Provides visual feedback and handles mouse events for column width adjustment.
 */
const ResizeHandle: React.FC<ResizeHandleProps> = ({
  columnKey,
  width,
  minWidth = 80,
  onResize,
}) => {
  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    const startX = e.clientX;
    const startWidth = width;

    const handleMouseMove = (moveEvent: MouseEvent) => {
      const delta = moveEvent.clientX - startX;
      const newWidth = Math.max(startWidth + delta, minWidth);
      onResize(columnKey, newWidth);
    };

    const handleMouseUp = () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseup', handleMouseUp);
  };

  return (
    <div
      onMouseDown={handleMouseDown}
      style={{
        position: 'absolute',
        top: 0,
        right: '-3px',
        width: '6px',
        height: '100%',
        cursor: 'col-resize',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
      }}
      title="Drag to resize column"
    >
      <div
        style={{
          width: '1px',
          height: '40%',
          backgroundColor: '#BDBDBD',
          transition: 'all 0.2s',
        }}
      />
    </div>
  );
};

export default ResizeHandle;
